// Access Control Module Types

export enum AccessType {
  QR_RESIDENT = 'QR_RESIDENT',
  QR_GUEST = 'QR_GUEST',
  QR_HIK = 'QR_HIK',
  PIN = 'PIN',
  LPR = 'LPR',
  MANUAL = 'MANUAL',
  APP_REMOTE = 'APP_REMOTE',
  RFID = 'RFID',
  REMOTE_OPEN = 'REMOTE_OPEN',
  FACEID = 'FACEID',
  FINGERPRINT = 'FINGERPRINT',
}

export enum AccessStatus {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
}

export enum DeviceType {
  VEHICLE_BARRIER = 'VEHICLE_BARRIER',
  PEDESTRIAN_GATE = 'PEDESTRIAN_GATE',
  CAMERA_LPR = 'CAMERA_LPR',
  CONTROLLER = 'CONTROLLER'
}

export enum DeviceStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE'
}

export enum PlateStatus {
  WHITELIST = 'WHITELIST',
  BLACKLIST = 'BLACKLIST'
}

export interface AccessLog {
  id: string;
  timestamp: string;
  memberId?: string | null;
  userId?: string;
  userName: string;
  guestId?: string | null;
  method: string;
  entryPoint: string;
  status: string;
  details?: string | null;
  plateNumber?: string | null;
  photos?: string[];
  photoUrl?: string | null;
}

export interface AccessDevice {
  id: string;
  name: string;
  type: DeviceType;
  ipAddress: string;
  location: string;
  status: DeviceStatus;
  externalDeviceId?: string | null;
}

export interface DeviceSyncResult {
  created: number;
  updated: number;
  deactivated: number;
  total: number;
}

export interface LicensePlate {
  id: string;
  number: string;
  alias: string;
  status: PlateStatus;
  notes?: string;
  addedAt: string;
}

// ============ UNIT ALLOWED DEVICES ============

export interface UnitAllowedDevice {
  id: string;
  name: string;
  externalDeviceId: string;
  status: 'ONLINE' | 'OFFLINE';
  location: string;
}

export interface AddUnitAllowedDeviceRequest {
  deviceId: string;
}

export interface AddUnitAllowedDeviceResponse {
  statusCode: 200 | 201;
  id: string;
  unitId: string;
  deviceId: string;
  deviceName: string;
  createdAt: string;
  createdBy: string;
}
